import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  MatButtonModule } from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTableModule} from '@angular/material/table';
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
  imports: [MatButtonModule,MatInputModule,MatCardModule, MatIconModule,MatSelectModule, MatToolbarModule, MatMenuModule, MatTabsModule, MatGridListModule, MatSnackBarModule, MatButtonToggleModule, MatTableModule, MatListModule, MatCheckboxModule, MatDialogModule ],
  exports: [MatButtonModule,MatInputModule,MatCardModule, MatIconModule, MatSelectModule, MatToolbarModule, MatMenuModule, MatTabsModule, MatGridListModule, MatSnackBarModule, MatButtonToggleModule, MatTableModule, MatListModule, MatCheckboxModule, MatDialogModule]
})
export class MaterialAppModule { }